import React, { Fragment } from "react";
import MenuNavHeader from "components/MenuNavHeader";
import { useFormikContext } from "formik";
import {
  CHECKOUT_PRODUCT_SETTINGS_INTENT,
  CHECKOUT_SETTINGS_INTENT
} from "utils/constants/checkout";
import {
  useFormCombinations,
  useIsManifestEditMode,
  useSetManifestLogicType
} from "utils/hooks/manifest";
import get from "lodash/get";
import {
  getManifestLogicTypeOptions,
  MANIFEST_LOGIC_TYPE_MAP
} from "utils/constants/manifest";
import { STATE_KEYS } from "utils/constants/state";
import { EDITOR_MODE } from "utils/constants/editor";
import OptionListPicker from "components/OptionListPicker";
import { LIST_PICKER_CUSTOM_CLASSES } from "utils/constants/ui";
import PlayVideoTrigger from "components/PlayVideoTrigger";
import { COMMAND_CONTENT_ID } from "components/CommandPalette/constants";
import { getIconForUID } from "components/FormerEditor/utils";
const ForwardIcon = getIconForUID("forward");

const Settings = (props) => {
  const {
    values,
    touched,
    setFieldValue,
    setFieldTouched
  } = useFormikContext();
  const isEditMode = useIsManifestEditMode();
  const typePath = `${props.name}.${STATE_KEYS.FORM.CONFIG_LOGIC_TYPE}`;
  const typeValue = get(values, typePath);
  const type = MANIFEST_LOGIC_TYPE_MAP[typeValue];
  const { hasConstantCheckoutPrimaries: hasConstant } = useSetManifestLogicType(
    {
      name: props.name
    }
  );
  const formCombos = useFormCombinations();
  const hasCombos = formCombos.length > 0;

  const inspectModeActive =
    get(values, STATE_KEYS.EDITOR.MODE) === EDITOR_MODE.INSPECT;

  const setModeAndIntent = ({ subIntent, thirdIntent }) => {
    if (inspectModeActive) {
      setFieldValue(STATE_KEYS.EDITOR.MODE, EDITOR_MODE.USE);
    }
    setFieldValue(STATE_KEYS.EDITOR.MENU_SUB_INTENT, subIntent || null);
    setFieldValue(STATE_KEYS.EDITOR.MENU_THIRD_INTENT, thirdIntent || null);
  };

  const logicTypeOptionProps = {
    value: type,
    name: typePath,
    multiselect: false,
    disabled: isEditMode,
    options: getManifestLogicTypeOptions({
      hasConstant,
      hasCombos
    }),
    onClick: (_, selectedValue) => {
      setFieldValue(typePath, selectedValue);
      if (!get(touched, typePath)) {
        setFieldTouched(typePath, true);
      }
    },
    hideIcon: true,
    canUnset: false,
    customClasses: LIST_PICKER_CUSTOM_CLASSES
  };

  return (
    <Fragment>
      <MenuNavHeader label="Settings" />
      <div className="pa3 flex flex-column bb hairline-1 bg-white bh--inset">
        <div className="flex flex-row w-100 justify-between items-center">
          <label className="fw6 f5 w-100">Checkout</label>
          <div className="flex flex-row">
            {/* Need checkout product settings required status  */}
            <PlayVideoTrigger />
          </div>
        </div>
        <div className="f6 w-100 lh-copy pt1">
          Set the requirements to enable the form checkout button.
        </div>
        <div className="pt2">
          <OptionListPicker {...logicTypeOptionProps} />
        </div>
        <div className="pt3">
          <div className="f6 w-100 lh-copy pt1">
            To require default and selected checkout values you must have
            settings for both.
          </div>
          <div className="pt2">
            <div
              className="f6 fw6 link__decoration--hover color-primary pointer flex items-center"
              onClick={() =>
                setModeAndIntent({
                  subIntent: CHECKOUT_SETTINGS_INTENT.SET_CONSTANT
                })
              }
            >
              Default checkout settings
              <div className="pl1 flex">
                <ForwardIcon />
              </div>
            </div>
          </div>
          <div className="pt2">
            <div
              className="f6 fw6 link__decoration--hover color-primary pointer flex items-center"
              onClick={() =>
                setModeAndIntent({
                  subIntent: CHECKOUT_SETTINGS_INTENT.SET_PRODUCTS,
                  thirdIntent: CHECKOUT_PRODUCT_SETTINGS_INTENT.SET_FIELDS
                })
              }
            >
              Field settings
              <div className="pl1 flex">
                <ForwardIcon />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Settings;
